import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { ByosStorage } from "@/features/byos/components/byos-storage";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { useI18n } from "@/providers/i18n-provider";
import { PageContainer } from "@fleet/ui";

function StoragePage() {
  const { t } = useI18n();
  return (
    <AuthPlaceholder
      title={t(msg`Your storage`)}
      description={t(msg`Connect your own storage and sync your folders directly to it.`)}
    >
      <PageContainer maxWidth="4xl">
        <ByosStorage />
      </PageContainer>
    </AuthPlaceholder>
  );
}

export const storageRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/storage",
  component: StoragePage,
});
